import React, { useState } from 'react';
import { Button, Upload, Space, Divider, Card, Typography, message, Tooltip } from 'antd';
import { DownloadOutlined, UploadOutlined, FileExcelOutlined, FilePdfOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const ExcelUploadSection = ({
  orderId,
  onUpload,
  onDownloadPdf,
  isUploading = false,
  isDownloadingPdf = false
}) => {
  const [fileList, setFileList] = useState([]);

  const resetFileSelection = () => {
    setFileList([]);
  };

  const handleUpload = () => {
    if (fileList.length === 0) {
      message.error('Lütfen bir Excel dosyası seçin');
      return;
    }

    const file = fileList[0].originFileObj;
    if (file) {
      onUpload(file, resetFileSelection);
    }
  };

  const uploadProps = {
    beforeUpload: (file) => {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                      file.type === 'application/vnd.ms-excel' ||
                      file.name.endsWith('.xlsx') ||
                      file.name.endsWith('.xls');

      if (!isExcel) {
        message.error('Yalnızca Excel dosyaları yükleyebilirsiniz!');
        return Upload.LIST_IGNORE;
      }

      return false;
    },
    onChange: ({ fileList: newFileList }) => {
      setFileList(newFileList);
    },
    fileList,
    maxCount: 1,
    accept: '.xlsx, .xls',
    onRemove: () => {
      setFileList([]);
    }
  };

  return (
    <Card className="mt-4" title={
      <Space>
        <FileExcelOutlined style={{ color: '#52c41a', fontSize: '18px' }} />
        <Title level={4} style={{ margin: 0 }}>Dosya İşlemleri</Title>
      </Space>
    }>
      <Space direction="horizontal" size="large" align="start" split={<Divider type="vertical" style={{ height: '100px' }} />}>
        {/* PDF Download Section */}
        <div>
          <Space>
            <Button
              type="primary"
              icon={<FilePdfOutlined />}
              onClick={onDownloadPdf}
              loading={isDownloadingPdf}
              disabled={isDownloadingPdf}
              style={{ backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }}
            >
              Siparişi PDF Olarak İndir
            </Button>
            <Tooltip title="Sipariş kalemlerini PDF dosyası olarak indirin (kartvizit dahil)">
              <InfoCircleOutlined />
            </Tooltip>
          </Space>
          <div>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              Sipariş kalemleri verilerini PDF olarak yazdırabilirsiniz
            </Text>
          </div>
        </div>

        {/* Excel Upload Section */}
        <div>
          <Space>
            <Upload {...uploadProps} listType="text">
              <Button icon={<UploadOutlined />}>Excel Dosyası Seç</Button>
            </Upload>

            <Button
              type="primary"
              icon={isUploading ? null : <UploadOutlined />}
              onClick={handleUpload}
              disabled={fileList.length === 0 || isUploading}
              loading={isUploading}
              style={{ backgroundColor: fileList.length > 0 && !isUploading ? '#52c41a' : undefined }}
            >
              Yükle
            </Button>
          </Space>
          <div>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              Yalnızca .xlsx veya .xls formatında dosyalar kabul edilmektedir
            </Text>
          </div>
        </div>
      </Space>
    </Card>
  );
};

export default ExcelUploadSection;
